import "@/polyfills";
import { createApp, h } from "vue";
import { createPinia } from "pinia";
import App from "@/App.vue";
import router from "@/router";
import "@/focus-visible";
import FloatingVue from "floating-vue";
import clickoutside from "@/directives/clickoutside";
import i18n from "@/i18n";
import setup from "@/services/apiclient/interceptors";

import "@/main.scss";
import "floating-vue/dist/style.css";
import "sweetalert2/src/sweetalert2.scss";
import "@/stories/styles.scss";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import { createProvider, filesRoot } from "@/vue-apollo";
import { sentryInit } from "@/sentry";
import type { IFeaturesFlag } from "@/interfaces";
import { createHead } from "@unhead/vue/client";

const app = createApp({
  render: () => h(App),
});

app.config.globalProperties.$filesRoot = filesRoot;

const pinia = createPinia();

app.use(FloatingVue, {
  themes: {
    "borger-default": {
      $extend: "tooltip",
    },
  },
});

app.directive("clickoutside", clickoutside);

setup();

// Set feature flags from query string.
(function () {
  const regex = /[&?]([\w]+)=(?:1|yes|true)/g;
  let match;
  const flags: Record<string, boolean> = {};
  while ((match = regex.exec(window.location.search))) {
    if (match[1]) {
      flags[match[1]] = true;
    }
  }
  app.config.globalProperties.$features = flags as IFeaturesFlag;
  window.$features = flags as IFeaturesFlag;
})();

sentryInit(app, router);

app.use(router);
app.use(createProvider());
app.use(i18n);
app.use(pinia);
app.use(createHead());
app.mount("#app");
